import DocumentUploadButton from './DocumentUploadButton';

export default DocumentUploadButton;